

<template>
  <div :class="view_class_view.div_container_section.container">

    <div :class="view_class_view.div_container_section.form">
        <table class="upload-document">
          <thead>
            <tr>
              <th>Documento</th>
              <th>Estatus</th>
              <th>Nombre del archivo</th>
              <th></th>
            </tr>
          </thead>
          <tbody v-for="(item, i) in listDocumentsAvailable"  :key="i">

            <tr v-show="item.max_documents_required == null || item.max_documents_required > 0">
              <td style="font-size:16px;font-family:Helvetica;font-weight: 400;vertical-align: top;">
                {{item.document_type}} <label style="font-weight: 900;" v-if="item.optional == false">*</label>
              </td>

              <td>
                <Check :visibility="item.document_id>0 ? '' : 'hidden'" style="margin:0px;" />
              </td>

              <td>
                {{ item.document_name }}
              </td>
              
              <td>
                <div v-show="item.document_type == 'Recibo pago parte social' && item.document_id == 0" style="display:flex;justify-content:right;margin-bottom:10px;">
                  <div style="ori">
                    <p class="subtitle" style="margin-top:5px;margin-bottom:0px;">
                      Fecha de depósito:
                    </p>
                    <date-picker
                      simple
                      color="#810042"
                      placeholder="Fecha de depósito"
                      locale="es"
                      input-format="DD/MM/YYYY"
                      @change="selectDate"
                      :localeConfig="{
                        es: {
                          displayFormat: 'DD/MM/YYYY',
                            lang: {
                              year: 'Año',
                              month: 'Mes',
                              day: 'Día',
                              label: '',
                              submit: 'Seleccionar',
                              cancel: 'Cancelar',
                              now: 'Hoy',
                              nextMonth: 'Siguiente',
                              prevMonth: 'Anterior',
                            },
                          }
                      }" />
                  </div>
                </div>
                <input 
                  type="button" 
                  :id="`upload_file_button_${i}_${item.abbreviation}`"
                  v-show="item.document_id <= 0" 
                  class="btn-load-document-desktop" value="Cargar archivo" 
                  v-on:click="uploadDocument(
                    item.abbreviation, 
                    item.document_type,
                    `input_file_upload_${i}_${item.abbreviation}`
                   )" />
                <button 
                  v-on:click="uploadDocument(
                    item.abbreviation, 
                    item.document_type,
                    `input_file_upload_${i}_${item.abbreviation}`
                   )" 
                  :id="`upload_file_button_mobile_${i}_${item.abbreviation}`"
                  v-show="item.document_id < 1"
                  class="btn-load-mobile" 
                  style="text-decoration:none;">
                  <p style="color:green">Cargar</p>
                </button>
                <input type="button" 
                  :id="`delete_file_button_${i}_${item.abbreviation}`"
                  v-show="item.document_id > 0" 
                  class="btn-delete-document btn-delete-desktop" 
                  value="Eliminar" 
                  v-on:click="deleteDocument(
                    item.abbreviation,
                    item.document_type,
                    item.document_id
                    )" />
                <button
                  :id="`delete_file_button_mobile_${i}_${item.abbreviation}`"
                  v-show="item.document_id > 0" 
                  v-on:click="deleteDocument(
                    item.abbreviation, 
                    item.document_type,
                    item.document_id
                   )"
                  class="btn-delete-mobile">
                  <p style="color:red">Eliminar</p>
                </button>
                <div style='height:0px;width:0px; overflow:hidden;' v-if="item.extension_allowed">
                  <input :id="`input_file_upload_${i}_${item.abbreviation}`" 
                    type="file" 
                    multiple="true" 
                    :accept="item.extension_allowed.split('|').join(',')"
                    @change="loadDocument($event, item.abbreviation, item.max_documents_required, item.extension_allowed.split('|'))" 
                    style="float:right" />
                </div>
              </td>
            </tr>

          </tbody>
        </table>
    </div>
  </div>
</template>
  
  <script>

  import { ref } from "vue";
  import Check from './Forms/VueCheck.vue';
  import Swal from "sweetalert2";
  import SwalAlertHelper from '@/helpers/swal-alert';
  import moment from "moment";
  
  export default {
    setup(props){
      const listDocumentsAvailable = ref(props.documents)

      // let keysDocument = ref([])
      // let documentsGroup = ref({})
      // documentsGroup.value = ManageList.groupByAbbreviation(listDocumentsAvailable.value.response.data);
      // keysDocument.value = ManageList.getNamePropertiesOfObject(documentsGroup.value)

      return {
        listDocumentsAvailable: listDocumentsAvailable.value.response.data
      }
    },
    data() {
      return {
        documentObjectClass: null,
        paymentDate: ""
      }
    },
    props: {
      documents:{
        type: Object
      },
      documentsRequired: {
        type: Array,
        default: () => [],
        required: true
      },
      maxSizeBytesToUpload: {
        type: Number,
        default: 16777216
      },
      maxSizeMegaBytesToUpload: {
        type: Number,
        default: 16
      },
      displayStatusMessage: {
        type: Boolean,
        default: true
      },
      view_class_view: 
        {
          type: Object,
          default: () => {
            return {
              div_container_error: {
                container: "",
                text_error: "",
              },
              div_container_section: {
                container: "",
                label: "",
                form: ""
              }
            }
          }
        }
    },
    name: 'UploadMultipleFilesComponent',
    components: {
      Check
    },
    beforeMount() {
      this.documentObjectClass = new Document();
      // console.log("🚀 ~ file: UploadMultipleFiles.vue:215 ~ mounted ~ this.documentObjectClass", this.documentObjectClass)
    },
    methods: {
      getRequiredFileStatus(){
        return this.documentsRequired;
      },
      getFile(selector) {
        if(selector.split("_")[3] == "RPPSOCIAL" && this.paymentDate == ""){
          Swal.fire({
            title: "Aviso",
            text:
              "Por favor ingrese una fecha válida de depósito, para continuar con la carga de documento.",
            icon: "warning",
            confirmButtonColor: '#FEB72B',
          });
          return;
        }
        this.documentObjectClass.getFileByIdSelector(selector);
      },
      loadDocument(event, type, maxDocumentsRequired=1, documentsAllowed) {
        const file = event.target.files;
        const fileAttributes = this.documentObjectClass.getDocumentAttributes(file);
  
        if (this.documentObjectClass.exceedTheMaximunSize(this.maxSizeBytesToUpload, fileAttributes.size)) {
          this.showExceedTheMaximunSizeMessage();
          return;
        }
  
        const isAllowed = this.documentObjectClass.documentExtensionIsAllowed(documentsAllowed, fileAttributes.completeExtension);
  
        if (!isAllowed) {
          this.isLoading = false;
          this.showExtensionIsNotAllowedMessage(documentsAllowed);
          return;
        }
          
        if(this.documentObjectClass.listDocuments.length > 0){
          if (!this.documentObjectClass.documentReachItsLimit(maxDocumentsRequired, type)) {
            if (this.documentObjectClass.fileHasAlreadyBeenUploaded(fileAttributes.name)) {
              this.isLoading = false;
              this.showFileDuplicatedMessage();
              return;
            }
          } else {
            this.showNumberFilesAllowedToAttachMessage(maxDocumentsRequired);
            return;
          }
        }
  
        this.documentObjectClass.serialize(file[0]).then(base64Response => {
          const newFile = this.documentObjectClass.addDocument(base64Response, fileAttributes.extension, fileAttributes.name, type);
          // console.log(newFile)
          if(this.displayStatusMessage){
            this.showLoadedDocumentSuccessMessage(fileAttributes.name);
          }
          
          this.$emit('upload-file', {
            newFile: newFile,
            enrollmentFeePaymentDate: this.paymentDate
          });
        }).catch(error => {
          console.error(error);
        });
      },
      uploadDocument(abbreviation, document_type, selector) {
        if(abbreviation == "RPPSOCIAL" && this.paymentDate == ""){
          Swal.fire({
            title: "Aviso",
            text:
              "Por favor ingrese una fecha válida de depósito, para continuar con la carga de documento.",
            icon: "warning",
            confirmButtonColor: '#FEB72B',
          });
          return;
        }

        // console.log(`type: ${abbreviation} name: ${document_type}`);
        Swal.fire({
          title: "Aviso",
          text: '¿Desea subir el siguiente documento? ',
          html: `<p style="font-size:14px;font-family:Helvetica;font-weight:400;">¿Desea subir el siguiente documento?<br/>
                  <span style="font-weight: bold; color:red">${document_type}</span>
                  </p>`,
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: '#FEB72B',
          cancelButtonColor: '#FEB72B',
          confirmButtonText: "SI",
          cancelButtonText: "NO"
        })
        .then((result) => {
          if (result.value) {
            let element = document.getElementById(selector);
            if(!element){
              throw "El elemento no encontrado";
            }
            element.value = "";
            element.click();
            this.$forceUpdate();
          }
        });
      },
      deleteDocument(abbreviation, document_type, document_id) {
        // console.log(`type: ${abbreviation} name: ${document_type}`);
        Swal.fire({
          title: "Aviso",
          text: '¿Desea eliminar el siguiente documento? ',
          html: `<p style="font-size:14px;font-family:Helvetica;font-weight:400;">¿Desea eliminar el siguiente documento?<br/>
                  <span style="font-weight: bold; color:red">${document_type}</span>
                  </p>`,
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: '#FEB72B',
          cancelButtonColor: '#FEB72B',
          confirmButtonText: "SI",
          cancelButtonText: "NO"
        })
        .then((result) => {
          if (result.value) {
            this.$emit('delete-file', {
              abbreviation: abbreviation,
              document_id: document_id,
              document_type: document_type
            });

            this.showDocumentSuccesfullyDeletedMessage();
            this.$forceUpdate();
          }
        });
        SwalAlertHelper.setIdAttributeToModalWindow('pop_upmodal_delete_file');
        SwalAlertHelper.setIdAttributeToButtons('button_delete_file_yes', 'button_delete_file_no');
      },
      showExtensionIsNotAllowedMessage(documentsAllowed) {
        Swal.fire({
          title: "Aviso",
          html: `<p style="font-family:Roboto;font-size:15px;">El tipo de archivo seleccionado no está permitido<br/><br/>
                    Archivos permitidos: <br/>
                  <span style="font-weight: 700;">${documentsAllowed.join(", ")}</span>
                  </p>`,
          text: "El tipo de archivo seleccionado no está permitido",
          icon: "error",
        });
        SwalAlertHelper.setIdAttributeToModalWindow('pop_upmodal_unsupported_file_type');
      },
      showDocumentSuccesfullyDeletedMessage() {
        Swal.fire({
          html: `<p style="font-size:14px;font-family:Helvetica;font-weight:400;">Documento Eliminado Correctamente</p>`,
          confirmButtonText: "Continuar",
          allowOutsideClick: false,
          icon: "success",
          confirmButtonColor: '#FEB72B',
        });
        SwalAlertHelper.setIdAttributeToModalWindow('pop_upmodal_successful_deleted');
      },
      showExceedTheMaximunSizeMessage() {
        Swal.fire({
          title: "Aviso",
          html: `<p style="font-family:Helvetica;font-size:15px;">El peso del archivo sobrepasa 
                    el limite establecido de <span style="font-weight: 700;">${this.maxSizeMegaBytesToUpload} MB</span>
                  </p>`,
          icon: "error",
        });
        SwalAlertHelper.setIdAttributeToModalWindow('pop_upmodal_unsupported_file_size');
      },
      showNumberFilesAllowedToAttachMessage(maxDocumentsRequired) {
        Swal.fire({
          title: "Aviso",
          text: `Solo puede subir ${maxDocumentsRequired} documentos`,
          icon: "error",
        });
      },
      showFileDuplicatedMessage() {
        Swal.fire({
          title: "Aviso",
          text: "El archivo seleccionado ya ha sido adjuntado",
          icon: "error",
        });
        SwalAlertHelper.setIdAttributeToModalWindow('pop_upmodal_fileduplicate', '');
      },
      showLoadedDocumentSuccessMessage(documentName) {
        Swal.fire({
          text: "Solicitud de prestamo guardada correctamente",
          html: `<p style="font-size:14px;font-family:Helvetica;font-weight:400;">El documento: <span style="font-weight:500;">${documentName}</span> se ha subido correctamente.</p>`,
          confirmButtonText: "Continuar",
          allowOutsideClick: false,
          icon: "success",
          confirmButtonColor: '#FEB72B',
        });
        SwalAlertHelper.setIdAttributeToModalWindow('pop_upmodal_successful_upload');
        SwalAlertHelper.setIdAttributeToButtons('button_ok_succes_file', '');
      },
      selectDate(event){
        if((moment(event._d).format("YYYY-MM-DD")) > (moment().format("YYYY-MM-DD"))){
          Swal.fire({
            title: "Aviso",
            text:
              "La fecha de depósito tiene que ser menor o igual a la actual.",
            icon: "warning",
            confirmButtonColor: '#FEB72B',
          });
          this.paymentDate = ""
          return;
        }
        else{
          this.paymentDate = moment(event._d).format("DD/MM/YYYY")
        }
      }
    }
  }



    
    class Document {
        _listDocuments = [];
        _extensionsAllowed = [];

        constructor() {
        }

        get listDocuments() {
            return this._listDocuments;
        }

        set listDocuments(listDocuments) {
            this._listDocuments = listDocuments;
        }

        get extensionsAllowed() {
            return this._extensionsAllowed;
        }

        set extensionsAllowed(extensionsAllowed) {
            this._extensionsAllowed = extensionsAllowed;
        }

        getDocumentAttributes = (document) => {
            const attributes = {
            name: document[0].name,
            extension: document[0].type.split('/')[1],
            completeExtension: `.${document[0].type.split('/')[1]}`,
            size: document[0].size,
            }
            
            return attributes;
        }

        getDocumentAttributesSimple = (document) => {
            const attributes = {
            name: document.name,
            extension: document.type.split('/')[1],
            completeExtension: `.${document.type.split('/')[1]}`,
            size: document.size,
            }
            
            return attributes;
        }

        documentExtensionIsAllowed = (extensionsAllowed, extension) => {
            if (extensionsAllowed.includes(extension))
            return true;
            return false;
        }

        documentReachItsLimit = (maxDocumentsRequired, type="") => {
            if (type == "") {
            if (this._listDocuments.length >= maxDocumentsRequired) {
                return true;
            }
            } else {
            const listDocumentsByType = this._listDocuments.filter(d => d.abbreviation == type);
            if (listDocumentsByType.length >= maxDocumentsRequired) {
                return true;
            }
            }
            
            return false;
        }

        fileHasAlreadyBeenUploaded = (newDocument) => {
            if (this._listDocuments.length > 0) {
            let indexDocuments = this._listDocuments.findIndex(d => d.name === newDocument);
            if (indexDocuments != -1)
                return true;
            return false;
            }
            return false;
        }
        
        addDocument = (fileBase64, extension, name, type="", remote_folder="documentos_alta_socios") => {
            const newDocument = {
            name: name,
            file: fileBase64,
            extension: extension,
            abbreviation: type,
            admission_request_id: 0,
            remote_folder: remote_folder
            }

            this._listDocuments.push(newDocument);

            return newDocument;
        }

        deleteDocument = (fileName, type="") => {
            try {
            if (this._listDocuments.length > 0) {
                const index = type == "" 
                ? this._listDocuments.findIndex(a => a.name == fileName) 
                : this._listDocuments.findIndex(a => a.name == fileName && a.abbreviation == type);

                if (index != -1)
                this._listDocuments.splice(index, 1)
            }
            return this._listDocuments;
            } catch (error) {
            throw "Error al intentar eliminar documento"
            }
        }
        
        exceedTheMaximunSize = (maxSize, size) => {
            if (size > maxSize)
            return true
            return false
        }

        getFileByIdSelector = (selector) => {
            document.getElementById(selector).value = "";
            document.getElementById(selector).click();
        }

        serialize = (file) => {
            const fileReader = new FileReader();
            
            return new Promise((resolve, reject) => {
            fileReader.onload = (fileEvent) => {
                let fileBase64 = fileEvent.target.result.split(',')[1];
                resolve(fileBase64);
            }

            fileReader.onerror = () => {
                reject('error, something went wrong with the file reader.')
            }

            fileReader.readAsDataURL(file);
            });
        }

        createDocumentsRequiredArray = (documentsRequired) => {
            return documentsRequired.map(d => ({
            abbreviation: d.abbreviation,
            documentAttached: false,
            id: d.id,
            name: d.name,
            max_documents_required: d.max_documents_required,
            allowedExtensions: d.extension,
            optional: d.optional,
            viewable: d.viewable
            }))
        }

        validateTypeFormat = (formats, typeFormat) => {
            for(const format of formats){
            if(format==typeFormat) return true
            }

            return false;
        }

        exceedTheMaximunSize = (maxSize, size) => {
            return size > maxSize;
        }

    }

    // class ManageList {

    //     static groupByAbbreviation(list){

    //         return JSON.parse(JSON.stringify(this.groupBy(list, (c) => c.abbreviation)));

    //     }

    //     static groupBy(xs, f) {

    //         return xs.reduce((r, v, i, a, k = f(v)) => ((r[k] || (r[k] = [])).push(v), r), {});

    //     }

    //     static getNamePropertiesOfObject(object){

    //         return Object.keys(object);

    //     }

    // }
</script>
  
  <style scoped>
  .btn-load-document-desktop {
    text-decoration:none;
    font-family:Helvetica;
    font-size: 13px;
    color:#8e8e8e;
    padding-top:5px;
    padding-bottom:5px;
    background-color:#FFF;
    border: 0px solid;
    border-color:#8e8e8e;
    border-width: 1px;
    border-radius:3px;
    width: 12em;
    outline:none;
    float:right;
    margin-right: 15px;
    visibility: visible;
  }
  
  .upload-document {
    border:1px solid #D2D2D2;
    border-radius: 1px !important;
    @apply shadow-md;
  }
  
  .upload-document tr td {
    border-bottom:1px solid #D2D2D2;
  }
  
  .subtable tr td {
    border-bottom: none;
  }
  
  .btn-load-mobile {
    text-decoration:none;
    visibility: hidden;
  }
  
  .btn-delete-document {
    text-decoration:none;
    font-family:Helvetica;
    font-size: 13px;
    color: red;
    padding-top:5px;
    padding-bottom:5px;
    background-color:#FFF;
    border: 0px solid;
    border-color:red;
    border-width: 1px;
    border-radius:3px;
    width: 12em;
    outline:none;
    float:right;
    margin-right:15px;
  }
  
  .btn-delete-mobile {
    text-decoration:none;
    visibility: hidden;
  }
  
  .tdButton {
    display:block;
  }
  
  .titles {
    font-size:13px;
    font-family:Helvetica;
    font-weight: 400;
    word-wrap: break-word;
  }
  
  .btn-delete-desktop {
    visibility: visible;
  }
  
  .subtable {
    width: 100%;
  }
  
  .tdTable {
    height: 40px;
    padding-left: 0 !important;
  }
  
  .body-half-screen{
    height: auto;
    max-height: 24vh;
  }
  
  .table-scroll{
    width:100%;
    /* display: block; */
    empty-cells: show;
    /* Decoration */
    border-spacing: 0;
  }
  
  .table-scroll thead{
    position:relative;
    display: block;
    width:100%;
    overflow-y: scroll;
  }
  
  .table-scroll tbody{
    /* Position */
    display: block; position:relative;
    width:100%; overflow-y:scroll;
    /* Decoration */
  }
  
  .table-scroll tr{
    width: 100%;
    display:flex;
  }
  
  ::-webkit-scrollbar {
    width: 5px;
  }
  
  /* Track */
  ::-webkit-scrollbar-track {
    box-shadow: inset 0 0 5px grey; 
    border-radius: 10px;
  }
   
  /* Handle */
  ::-webkit-scrollbar-thumb {
    background: #8E8E8E; 
    border-radius: 10px;
  }
  
  /* Handle on hover */
  ::-webkit-scrollbar-thumb:hover {
    background: #8E8E8E; 
  }
  
  .table-scroll td,.table-scroll th{
    /* flex-basis:100%; */
    display: block;
    padding: 1rem;
    text-align:left;
  }
  
  .table-scroll.small-first-col td:first-child,
  .table-scroll.small-first-col th:first-child{
    flex-basis:20%;
    flex-grow:1;
  }
  
  table.upload-document,table.rwd_auto {width:100%;margin:0 0 50px 0;}
    .upload-document th,.rwd_auto th {background:#fff;padding:5px;text-align:left;}
    .upload-document td,.rwd_auto td {padding:5px;text-align:left}
    .upload-document tr:last-child td, .rwd_auto tr:last-child td{border:0;}
    .upload-document thead tr {border-bottom:1px solid #ccc;color:#3B3B3B;font-size:16px !important;font-family:Helvetica !important;font-weight: 400 !important;}
    .upload-document tbody td {color:#3B3B3B;}
  
  @media only screen and (max-width: 1024px)  
  {
    table.upload-document, .upload-document thead, .upload-document tbody, .upload-document th, .upload-document td, .upload-document tr { display: block; }
    .upload-document thead tr { position: absolute;top: -9999px;left: -9999px; }
    .upload-document tr { border-bottom: 1px solid #ccc; }
    .upload-document td { position: relative;padding-left: 40%;text-align:left; }
    .upload-document td:before {  position: absolute; top: 6px; left: 6px; width: 45%; padding-right: 10px; white-space: nowrap;}
    .upload-document td:nth-of-type(1):before { 
      content: "Documento:"; 
      color: #3B3B3B;
      font-family:Helvetica;
      font-weight: 700;
    }
    .upload-document td:nth-of-type(2):before { 
      content: "Estatus:"; 
      color: #3B3B3B;
      font-family:Helvetica;
      font-weight: 700;
    }
    .upload-document td:nth-of-type(3):before { 
      content: "Nombre:"; 
      color: #3B3B3B;
      font-family:Helvetica;
      font-weight: 700;
    }
    .upload-document td:nth-of-type(4):before { content: ""; }
    .descarto {display:none;}
    .fontsize {font-size:10px;}
  }
  
  @media only screen and (max-width: 1024px)  
  {
    .subtable, .subtable thead, .subtable tbody, .subtable th, .subtable td, .subtable tr { display: block; }
    .subtable thead tr { position: absolute;top: -9999px;left: -9999px; }
  
    .subtableid td,.subtableid th {
      display: block;
      padding: 1rem;
      text-align:left;
    }
    
    .subtable td {position: relative;padding-left: 40%;text-align:left; }
    .subtable td:before {  position: absolute; top: 6px; left: 6px; width: 45%; padding-right: 10px; white-space: nowrap;}
    .subtable td:nth-of-type(1):before { content: ""; }
    .subtable td:nth-of-type(2):before { content: ""; }
    .subtable td:nth-of-type(3):before { content: ""; }
    .subtable td:nth-of-type(4):before { content: ""; }
    .descarto {display:none;}
    .fontsize {font-size:10px;}
  }
  
  @media only screen and (max-width: 1024px)  
  {
    .btn-delete-mobile {
      visibility: visible !important;
    }
  
    .tdButton {
      display:none !important;
    }
  
    .tdTable {
      height: auto;
      padding-left: 0px;
    }
  
    .btn-delete-desktop {
      visibility: hidden;
    }
  
    .btn-load-mobile {
      visibility: visible;
    }
  
    .btn-load-document-desktop {
      visibility: hidden;
    }
  }
  </style>